// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"661":"0bf4afdf","850":"80718b4c","854":"436e5368","874":"021c286b","937":"726c7790"}[chunkId] + ".chunk.js";
};